<template>
  <footer class="brand-footer">
    <div class="wrap">
      <div class="foot-grid">
        <div class="col">
          <h4>{{ brandTitle }}</h4>
          <p>如有任何產品、課程相關問題歡迎與我們聯繫</p>
          <div class="sicons" aria-label="社群圖示">
            <a v-if="instagram" :href="instagram" aria-label="Instagram" target="_blank" rel="noopener" />
            <a v-if="messenger" :href="messenger" aria-label="Messenger" target="_blank" rel="noopener" />
            <a v-if="line" :href="line" aria-label="LINE" target="_blank" rel="noopener" />
          </div>
        </div>
        <div class="col">
          <h4>聯絡方式</h4>
          <ul class="contact">
            <li v-if="instagram">IG：{{ instagram }}</li>
            <li v-if="line">LINE：{{ line }}</li>
            <li v-if="email">E-mail：{{ email }}</li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
interface FooterInfo {
  brandTitle?: string
  instagram?: string
  messenger?: string
  line?: string
  email?: string
}
const props = defineProps<FooterInfo>()
const brandTitle = props.brandTitle
const { instagram, messenger, line, email } = props
</script>

<style scoped lang="scss">
.wrap {
  max-width: var(--max, 1200px);
  margin-inline: auto;
  padding-inline: clamp(16px, 3vw, 28px);
}

.brand-footer {
  background: var(--dark, #2c2c2c);
  color: #fff;
  padding: var(--s8, 48px) 0 var(--s5, 20px);
}

.brand-footer .foot-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  align-items: start;
}

.brand-footer h4 {
  margin: 0 0 var(--s4, 16px);
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--primary, #c9a876);
}

.brand-footer p,
.brand-footer li {
  color: rgba(255, 255, 255, 0.8);
  margin: 0.4rem 0;
  line-height: 1.6;
}

.brand-footer .sicons {
  display: flex;
  gap: 12px;
  margin-top: var(--s4, 16px);
}

.brand-footer .sicons a {
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.05);
  transition: all 0.3s ease;
}

.brand-footer .sicons a:hover {
  border-color: var(--primary, #c9a876);
  background: var(--primary, #c9a876);
  transform: translateY(-2px);
}

.brand-footer .sicons svg {
  width: 18px;
  height: 18px;
  fill: #fff;
}

.brand-footer .contact {
  list-style: none;
  margin: 0;
  padding: 0;
}

@media (max-width: 900px) {
  .brand-footer .foot-grid {
    grid-template-columns: 1fr;
    gap: 24px;
  }
}
</style>
